import { NarratorNPC } from '../../../src/feature/narrator/narrator.model';
import { bathMaid } from './bathmaid/npc';
import { fishermanBeggen } from './fisherman/npc';
import { hunter } from './hunter/npc';
import { innKeeper } from './inkeeper/npc';
import { lordBourscheid } from './lord_bourscheid/npc';
import { merchantBeggen } from './merchant/npc';
import { miller } from './miller/npc';
import { niklas } from './niklas/npc';
import { oakBeggen } from './oak/npc';
import { priestBeggen } from './priest/npc';
import { reeveBeggen } from './reeve/npc';
import { townsfolk } from './townsfolk/npc';

export const narrators: NarratorNPC[] = [
  bathMaid,
  innKeeper,
  hunter,
  miller,
  niklas,
  lordBourscheid,
  townsfolk,
  fishermanBeggen,
  oakBeggen,
  merchantBeggen,
  priestBeggen,
  reeveBeggen,
];
